module.exports = __webpack_public_path__ + "static/media/lightning-white.2300875e.svg";